/*******************************************************************************
 * @ngdoc  provider
 * @name   ServicesProvider
 * @description
 * Provides configuration of the OurOrg Services service.
 *******************************************************************************/
/* @ngInject */ export function OurOrgServicesProvider() {
  this.httpServiceBase = '/books/ourOrg/';
  this.httpServices = (http) => ({
    getBankAccounts: () => http.get('getBankAccounts'),
    getKpsActiveFlags: () => http.get('getKpsActiveFlags'),
    getOrganization: () => http.get('getOrganization'),
    getProcessorAccounts: () => http.get('getProcessorAccounts'),
    getProcessors: () => http.get('getProcessors'),
    saveOrganization: (org) => http.post('saveOrganization', org),
    saveProcessor: (processor) => http.post('saveProcessor', processor),

    /*-------------------------------------------------------------*/
    /* TODO: `forPOS` can be removed when OpenEdge TransactionsAPI */
    /* TODO: is used for POS instead of HostPay. - #openedge       */
    /*-------------------------------------------------------------*/
    testTokens: (ptype, forPOS, tokens) =>
      http.post(`testTokens/${ptype}/${forPOS}`, tokens)
  });
  
  /*******************************************************************************
   * service */
  /**
   * @ngdoc        service
   * @name         Services
   * @module       csm.books.OurOrg
   * @description  Services for OurOrg calls to the server.
   *******************************************************************************/
  this.$get = ['HTTPService', function (HTTPService) {
    return HTTPService.make(this.httpServiceBase, this.httpServices);
  }];
}